import React, { FC, ReactNode, createContext, useContext } from "react";
import { apollo } from "..";
import { getEnv, Env } from "../../utils/getEnv";

export const ONE_IO_API: Record<Env, string> = {
  local: "http://localhost:4000",
  dev: "https://authorizer.dev.account.carrier.io/graphql",
  qa: "https://authorizer.qa.account.carrier.io/graphql",
  uat: "https://authorizer.preprod.account.carrier.io/graphql",
  prod: "https://authorizer.preprod.account.carrier.io/graphql",
};

const authnClient = new apollo.ApolloClient({
  link: new apollo.HttpLink({
    uri: ONE_IO_API[getEnv(window.location.hostname)],
  }),
  cache: new apollo.InMemoryCache(),
});

const AuthnContext = createContext(authnClient);

export const useAuthnClient = () => useContext(AuthnContext);

export const AuthnClientProvider: FC<{ children: ReactNode }> = ({
  children,
}) => (
  <apollo.ApolloProvider client={authnClient}>{children}</apollo.ApolloProvider>
);
